import { render, staticRenderFns } from "./projectLeft.vue?vue&type=template&id=2f9510b0&scoped=true&"
import script from "./projectLeft.vue?vue&type=script&lang=js&"
export * from "./projectLeft.vue?vue&type=script&lang=js&"
import style0 from "./projectLeft.vue?vue&type=style&index=0&id=2f9510b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9510b0",
  null
  
)

export default component.exports